<template>
  <div class="sky_wrap">
    <div class="sky_img" :style="{ background: `url(${prodTwo1.image}) 0 0 no-repeat`, backgroundSize: '100% 100%' }"
      v-if="hiddenProdTwo1">
      <div class="img_tit hidden-xs-only">
        {{ prodTwo1.title }}
      </div>
      <div class="img_desc hidden-xs-only">
        <p v-html="prodTwo1.subtitle"></p>
      </div>
      <div class="img_tit hidden-sm-and-up">
        <p v-html="prodTwo1.subtitle"></p>
      </div>
      <!-- <div class="img_btn" @click="handleToDemo">立即体验</div> -->
    </div>

    <div class="two_level" v-if="hiddenProdTwo2">
      <div class="two_level_wrap">
        <div class="two_left">
          <div class="tit">{{ prodTwo2.title }}</div>
          <div class="left_list" v-for="(item, index) in prodTwo2Children" :key="item.id">
            <div class="list_item">
              <span>{{ index + 1 }}、</span>{{ item.title }}
            </div>
          </div>
        </div>
        <div class="two_right">
          <img :src="prodTwo2.image" alt="" />
        </div>
      </div>
    </div>

    <template v-if="hiddenProdTwo3">
      <div class="sky_title_wrap">
        <div class="sky_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="sky_title">{{ prodTwo3.title }}</div>
            <div class="sky_desc">
              {{ prodTwo3.subtitle }}
            </div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>

      <div class="sky_card">
        <SkyCard :skyList="skyList" :detailsArr="prodTwo3Children" ref="skyCard" />
      </div>
    </template>

    <div class="three_level" v-if="hiddenProdTwo4"
      :style="{ 'background': `url(${prodTwo4.image}) 0 0 no-repeat`, backgroundSize: '100%' }">
      <div class="three_content">
        <p v-html="prodTwo4.title"></p>
        <!-- <el-button plain round class="three_btn" @click="handleToDemo">申请免费体验</el-button> -->
      </div>
    </div>

    <template v-if="hiddenProdTwo5">
      <div class="sky_title_wrap">
        <div class="sky_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="sky_title">{{ prodTwo5.title }}</div>
            <div class="sky_desc">
              {{ prodTwo5.subtitle }}
            </div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>

      <div class="four_level">
        <div class="four_img hidden-xs-only">
          <img :src="prodTwo5.image" alt="" />
        </div>
        <div class="four_right">
          <div class="four_tit">{{ prodTwo5Children.title }}</div>
          <div class="four_zhengfangxing">
            <img src="@/assets/img/zhengfangxing.png" alt="" />
          </div>
          <div class="four_desc">
            {{ prodTwo5Children.subTitle }}
          </div>
          <!-- <el-button class="four_btn" @click="handleToDemo">进入药选址</el-button> -->
        </div>
      </div>
    </template>

    <!-- <div class="four_level_mobile hidden-sm-and-up">
      <img src="../../assets/img/12d29ab7b6.png" alt="" />
      <el-button class="four_mobile_btn">申请免费体验</el-button>
    </div> -->

    <div class="sky_shows_wrap" v-if="hiddenProdTwo6">
      <div class="sky_title_wrap">
        <div class="sky_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="sky_title">{{ prodTwo6.title }}</div>
            <div class="sky_desc">{{ prodTwo6.subtitle }}</div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="sky_shows_imgs">
        <img :src="prodTwo6.image" alt="" />
      </div>
    </div>

    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import SkyCard from './SkyCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Constant from '../../utils/Constant';
import { leftLikeDict } from '../../api/system';
import { findDictHidden, findMainProp, findMainPropArr, transDictDataNotTypeMore, transDictDataTotal } from '../../utils';
export default {
  data() {
    return {
      hiddenProdTwo1: true,
      hiddenProdTwo2: true,
      hiddenProdTwo3: true,
      hiddenProdTwo4: true,
      hiddenProdTwo5: true,
      hiddenProdTwo6: true,
      prodTwo1: {},
      prodTwo2: {},
      prodTwo2Children: [],
      prodTwo3: {},
      prodTwo3Children: [],
      prodTwo3Arr: [],
      prodTwo4: {},
      prodTwo5: {},
      prodTwo6: {},
      prodTwo5Children: {},
      skyList: [],
    }
  },
  methods: {
    handleToDemo() {
      // this.$router.push('/demo')
    },
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.PROD_TWO1);
      if (res.data) {
        this.hiddenProdTwo1 = findDictHidden(Constant.PROD_TWO1, res.data.data)
        if (this.hiddenProdTwo1) {
          this.prodTwo1 = findMainProp(res.data.data, Constant.PROD_TWO1)
        }
      }
      const res2 = await leftLikeDict(Constant.PROD_TWO2);
      if (res2.data) {
        this.hiddenProdTwo2 = findDictHidden(Constant.PROD_TWO2, res2.data.data)
        if (this.hiddenProdTwo2) {
          this.prodTwo2 = findMainProp(res2.data.data, Constant.PROD_TWO2)
          this.prodTwo2Children = transDictDataNotTypeMore(res2.data.data.find(v => v.dictKey === 'prod_two2Title')?.children, 'prod_two2Content')
        }
      }
      const res3 = await leftLikeDict(Constant.PROD_TWO3);
      if (res3.data) {
        this.hiddenProdTwo3 = findDictHidden(Constant.PROD_TWO3, res3.data.data)
        if (this.hiddenProdTwo3) {
          this.prodTwo3 = findMainProp(res3.data.data, Constant.PROD_TWO3)
          this.prodTwo3Arr = findMainPropArr(res3.data.data, Constant.PROD_TWO3)
          this.skyList = this.prodTwo3Arr.reduce((pre, cur) => {
            pre.push({
              tit: cur.type
            })
            return pre
          }, [])
          let totalArr = []
          totalArr = [...totalArr, ...(res3.data.data.find(v => v.dictKey === 'prod_two3Type1')?.children || [])]
          totalArr = [...totalArr, ...(res3.data.data.find(v => v.dictKey === 'prod_two3Type2')?.children || [])]
          totalArr = [...totalArr, ...(res3.data.data.find(v => v.dictKey === 'prod_two3Type3')?.children || [])]
          this.prodTwo3Children = transDictDataTotal(totalArr, 'prod_two3Content')
          setTimeout(() => {
            this.$refs.skyCard?.changeIndex(0)
          });
        }
      }
      const res4 = await leftLikeDict(Constant.PROD_TWO4);
      if (res4.data) {
        this.hiddenProdTwo4 = findDictHidden(Constant.PROD_TWO4, res4.data.data)
        if (this.hiddenProdTwo4) {
          this.prodTwo4 = findMainProp(res4.data.data, Constant.PROD_TWO4)
        }
      }
      const res5 = await leftLikeDict(Constant.PROD_TWO5);
      if (res5.data) {
        this.hiddenProdTwo5 = findDictHidden(Constant.PROD_TWO5, res5.data.data)
        if (this.hiddenProdTwo5) {
          this.prodTwo5 = findMainProp(res5.data.data, Constant.PROD_TWO5)
          this.prodTwo5Children = transDictDataNotTypeMore(res5.data.data.find(v => v.dictKey === 'prod_two5Title')?.children, 'prod_two5Content')[0] || {}
        }
      }
      const res6 = await leftLikeDict(Constant.PROD_TWO6);
      if (res6.data) {
        this.hiddenProdTwo6 = findDictHidden(Constant.PROD_TWO6, res6.data.data)
        if (this.hiddenProdTwo6) {
          this.prodTwo6 = findMainProp(res6.data.data, Constant.PROD_TWO6)
        }
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  },
  components: {
    SkyCard,
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.sky_wrap {
  .sky_img {
    width: 100%;
    height: 600px;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;

      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .two_level {
    width: 100%;
    background: #f4f9fc;
    padding: 50px 0;
    padding-top: 100px;

    .two_level_wrap {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        width: 90%;
      }

      .two_left {
        flex: 1;
        display: flex;
        flex-direction: column;

        .tit {
          color: #2091d3;
          font-size: 30px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 1.2rem;
          }
        }

        .left_list {
          margin-top: 30px;

          &:nth-child(2) {
            margin-top: 50px;
          }

          .list_item {
            color: #666;
            width: 100%;
            height: 70px;
            display: flex;
            align-items: center;
            background: url('../../assets/img/bg123.png') -20px 0 no-repeat;
            background-size: 100% 100%;
            font-size: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            @media screen and (max-width: 768px) {
              font-size: 0.8rem;
              height: 70px;
              white-space: pre-wrap;
              padding: 0 10px;
            }

            span {
              color: #2091d3;
              font-size: 24px;
              padding: 0 10px;

              @media screen and (max-width: 768px) {
                font-size: 1.2rem;
              }
            }
          }
        }
      }

      .two_right {
        flex: 1;
        margin-left: 60px;
        display: flex;
        align-items: center;

        img {
          width: 90%;
        }
      }
    }
  }

  .sky_title_wrap {
    width: 100%;
    margin-top: 50px;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .sky_inner {
      display: flex;
      justify-content: center;

      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }

      .inner_center {
        width: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;

        @media screen and (max-width: 768px) {
          flex: 2.2;
        }

        .sky_title {
          font-size: 40px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .sky_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;

          @media screen and (max-width: 768px) {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }

      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }
    }
  }

  .sky_card {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  .three_level {
    width: 100%;
    height: 540px;
    background-size: cover;
    position: relative;

    .three_content {
      position: absolute;
      left: 10%;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;

      p {
        font-size: 20px;
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }

      .three_btn {
        background: transparent;
        color: #fff;

        &:hover {
          color: #2091d3;
        }
      }
    }
  }

  .four_level {
    width: 70%;
    margin: 50px auto;
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px) {
      width: 90%;
      padding: 30px 0 50px 0;
    }

    .four_img {
      width: 60%;

      img {
        width: 80%;
      }
    }

    .four_right {
      width: 40%;
      height: 400px;
      padding: 80px 30px;
      margin-left: -10px;
      background: #f4f9fc;

      @media screen and (max-width: 768px) {
        width: 100%;
        background: #fff;
      }

      .four_tit {
        font-size: 20px;
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-size: 1.4rem;
        }
      }

      .four_zhengfangxing {
        width: 10%;
        padding: 10px 0;

        img {
          width: 100%;
        }
      }

      .four_desc {
        color: #5b6e74;
        font-size: 15px;
        margin-top: 20px;
        line-height: 22PX;

        @media screen and (max-width: 768px) {
          font-size: 0.8rem;
        }
      }

      .four_btn {
        background: #feb65c;
        color: #fff;
        border-radius: 20px;
        margin-top: 50px;

        @media screen and (max-width: 768px) {
          width: 90px;
          height: 35px;
          border-radius: 20px;
          margin-top: 20px;
          font-size: 14px;
        }
      }
    }
  }

  .four_level_mobile {
    width: 100%;
    position: relative;

    @media screen and (max-width: 768px) {
      margin-top: 100px;
    }

    .four_mobile_btn {
      border-radius: 20PX;
      width: 120PX;
      height: 40PX;
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      background: transparent;

      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    img {
      width: 100%;
    }
  }

  .sky_shows_wrap {
    width: 100%;
    background: url('../../assets/img/witness-bgc369221.png') 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: 100px;
    box-sizing: border-box;

    .sky_shows_imgs {
      display: flex;
      justify-content: center;
      margin-top: 50px;

      img {
        @media screen and (max-width: 768px) {
          width: 90%;
          margin: 10px;
        }
      }
    }
  }
}
</style>